import React, { useState } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import { Container, Row, Col, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router";

//  API
import useAdminData from "../../hooks/useAdminData";

//  Components
import Spinner from "../Spinner";
import { TextInput, TextArea, FileInput } from '../Inputs';

const EditProjectForm = ({ project, index }) => {
    const { updateProject, error, isLoading } = useAdminData();
    const navigate = useNavigate();
    const [success, setSuccess] = useState(false);

    return (
        <Formik
            initialValues={{ ...project }}
            enableReinitialize
            validationSchema={Yup.object({
                name: Yup.string()
                    .max(40, "⚠️ Must have 40 characters, at most")
                    .min(2, "⚠️ Must have 2 characters, at least"),
                description: Yup.string(),
                link: Yup.string(),
                language: Yup.string(),
                framework: Yup.string(),
                type: Yup.array().of(Yup.string()),
                classes: Yup.string(),
                image: Yup.mixed(),
            })}
            onSubmit={async (values, { setSubmitting }) => {
                let data = new FormData();
                data.append("name", values.name);
                data.append("image", values.image);
                data.append("description", values.description);
                data.append("link", values.link);
                data.append("language", values.language);
                data.append("framework", values.framework);
                data.append("classes", values.classes);
                values.type.forEach(t => data.append("type", t));

                await updateProject(project._id, data, index).then(result => {
                    setSubmitting(false);
                    setSuccess(true);
                    setTimeout(() => {
                        navigate('/admin');
                    }, 3000);
                });
            }}
        >
            {formik => (
                <Form className="mb-5 mt-4">
                    <div className="form">
                        <Container>
                            <div className="form-box jumbotron jumbotron-fluid bg-light">
                                <Container>
                                    <Row>
                                        <Col>
                                            <Container className="py-3">
                                                <Row className="mb-3">
                                                    <Col xs={12} md={6}>
                                                        <TextInput
                                                            label="Name"
                                                            name="name"
                                                            type="text"
                                                            placeholder={
                                                                project.name
                                                            }
                                                        />
                                                    </Col>
                                                    <Col xs={12} md={6}>
                                                        <TextInput
                                                            label="Link"
                                                            name="link"
                                                            type="text"
                                                            placeholder={
                                                                project.link
                                                            }
                                                        />
                                                    </Col>
                                                    <Col xs={12} md={6}>
                                                        <TextInput
                                                            label="Language"
                                                            name="language"
                                                            type="text"
                                                            placeholder={
                                                                project.language
                                                            }
                                                        />
                                                    </Col>
                                                    <Col xs={12} md={6}>
                                                        <TextInput
                                                            label="Framework"
                                                            name="framework"
                                                            type="text"
                                                            placeholder={
                                                                project.framework
                                                            }
                                                        />
                                                    </Col>
                                                    <Col xs={12} md={6}>
                                                        <TextInput
                                                            label="Classes"
                                                            name="classes"
                                                            type="text"
                                                            placeholder={
                                                                project.classes
                                                            }
                                                        />
                                                    </Col>
                                                    <Col xs={12} md={6}>
                                                        <FieldArray name="type">
                                                            {({
                                                                remove,
                                                                push,
                                                            }) => (
                                                                <>
                                                                    {formik
                                                                        .values
                                                                        .type
                                                                        .length >
                                                                        0 &&
                                                                        formik.values.type.map(
                                                                            (
                                                                                type,
                                                                                index
                                                                            ) => (
                                                                                <section
                                                                                    key={
                                                                                        index
                                                                                    }
                                                                                >
                                                                                    <div className="form__group field mb-1">
                                                                                        <Field
                                                                                            className="form__field"
                                                                                            name={`type.${index}`}
                                                                                            type="text"
                                                                                            placeholder={
                                                                                                type
                                                                                            }
                                                                                        />
                                                                                        <label
                                                                                            htmlFor={`type.${index}`}
                                                                                            className="form__label"
                                                                                        >
                                                                                            Type
                                                                                        </label>
                                                                                    </div>

                                                                                    <Button
                                                                                        variant="danger"
                                                                                        onClick={() =>
                                                                                            remove(
                                                                                                index
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Delete
                                                                                    </Button>
                                                                                </section>
                                                                            )
                                                                        )}
                                                                    <Button
                                                                        onClick={() =>
                                                                            push(
                                                                                ""
                                                                            )
                                                                        }
                                                                    >
                                                                        New type
                                                                    </Button>
                                                                </>
                                                            )}
                                                        </FieldArray>
                                                    </Col>
                                                    <Col xs={12} md={6}>
                                                        <FileInput
                                                            label="Image"
                                                            name="image"
                                                            type="file"
                                                            onChange={event => {
                                                                formik.setFieldValue(
                                                                    "image",
                                                                    event.target
                                                                        .files[0]
                                                                );
                                                            }}
                                                            accept="image/*"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <TextArea
                                                            label="Description"
                                                            name="description"
                                                            type="text"
                                                            placeholder={
                                                                project.description
                                                            }
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="text-end">
                                                    <Col>
                                                        <Button
                                                            type="button"
                                                            variant="danger"
                                                            className="fs-10 mx-3"
                                                            onClick={() =>
                                                                navigate(-1)
                                                            }
                                                        >
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            type="submit"
                                                            variant="primary"
                                                            disabled={
                                                                formik.isSubmitting ||
                                                                !formik.isValid
                                                            }
                                                            className="fs-10"
                                                        >
                                                            Save
                                                        </Button>
                                                    </Col>
                                                </Row>

                                                {error && (
                                                    <Row className="text-center">
                                                        <Col>
                                                            <p className="text-danger">
                                                                Error while changing project info!
                                                                <br />
                                                                Cause: {error}
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                )}
                                                {formik.isSubmitting &&
                                                    isLoading && (
                                                        <Spinner color="red" />
                                                    )}
                                                {success && (
                                                    <Row className="text-center my-1">
                                                        <Col>
                                                            <Alert variant="success">
                                                                Changes saved successfully!
                                                            </Alert>
                                                        </Col>
                                                    </Row>
                                                )}
                                            </Container>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </Container>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default EditProjectForm;
